import { Controller } from "@hotwired/stimulus"

// daisyUI alert color variants — maps straight to `alert-${variant}` + the
// matching icon in the toast partial.
type Variant = "success" | "error" | "warning" | "info"

// Shows transient daisyUI toasts (bottom-right). Trigger one from anywhere with
//   this.dispatch("show", { prefix: "toast", target: window, detail: { message, variant } })
// The markup (per-variant icons) lives in the toast partial; nothing is built here.
export default class extends Controller {
  static targets = ["template"]
  static values = { duration: { type: Number, default: 4000 } }

  declare readonly templateTarget: HTMLTemplateElement
  declare readonly durationValue: number

  show(event: CustomEvent<{ message?: string; variant?: Variant }>) {
    const { message, variant = "success" } = event.detail ?? {}
    if (!message) return

    const toast = this.templateTarget.content.firstElementChild?.cloneNode(true)
    if (!(toast instanceof HTMLElement)) return

    toast.classList.add(`alert-${variant}`)
    toast.querySelector(`[data-toast-icon="${variant}"]`)?.classList.remove("hidden")

    const slot = toast.querySelector<HTMLElement>("[data-toast-message]")
    if (slot) slot.textContent = message

    this.element.appendChild(toast)
    setTimeout(() => toast.remove(), this.durationValue)
  }
}
